import React, { useState } from 'react';
import './index.css';

const WritePost = () => {
  const [post, setPost] = useState({
    title: '',
    category: '',
    tags: '',
    content: ''
  });
  const [isPreview, setIsPreview] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPost(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // 实际应用中这里会调用API保存文章
    console.log('发布文章:', post);
    alert('文章发布成功！');
    setPost({ title: '', category: '', tags: '', content: '' });
  };

  const handleSaveDraft = () => {
    console.log('保存草稿:', post);
    alert('草稿保存成功！');
  };

  const handleAddTag = (tag) => {
    const currentTags = post.tags ? post.tags.split(',') : [];
    if (!currentTags.includes(tag)) {
      setPost(prev => ({
        ...prev,
        tags: [...currentTags, tag].join(',')
      }));
    }
  };

  const suggestedTags = ['技术', '生活', '学习', '旅行', '美食', '思考', '分享'];

  return (
    <div className="write-post-page">
      <div className="stars-bg"></div>
      
      <div className="container">
        <div className="write-header">
          <h1 className="page-title">写文章</h1>
          <p className="page-subtitle">在星空下记录你的思考与发现</p>
        </div>

        <form className="write-form purple-card" onSubmit={handleSubmit}>
          <div className="form-header">
            <div className="form-actions">
              <button 
                type="button"
                className={`mode-btn ${!isPreview ? 'active' : ''}`}
                onClick={() => setIsPreview(false)}
              >
                ✏️ 编辑
              </button>
              <button 
                type="button"
                className={`mode-btn ${isPreview ? 'active' : ''}`}
                onClick={() => setIsPreview(true)}
              >
                👁️ 预览
              </button>
            </div>
          </div>

          {!isPreview ? (
            <>
              <div className="form-group">
                <input
                  type="text"
                  name="title"
                  value={post.title}
                  onChange={handleInputChange}
                  className="post-title-input purple-input"
                  placeholder="请输入文章标题"
                  required
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <select
                    name="category"
                    value={post.category}
                    onChange={handleInputChange}
                    className="purple-input"
                    required
                  >
                    <option value="">选择分类</option>
                    <option value="技术分享">技术分享</option>
                    <option value="生活随笔">生活随笔</option>
                    <option value="旅行记录">旅行记录</option>
                    <option value="学习笔记">学习笔记</option>
                  </select>
                </div>

                <div className="form-group">
                  <input
                    type="text"
                    name="tags"
                    value={post.tags}
                    onChange={handleInputChange}
                    className="purple-input"
                    placeholder="输入标签，用逗号分隔"
                  />
                  <div className="tag-suggestions">
                    <span className="suggestion-label">快速标签：</span>
                    {suggestedTags.map(tag => (
                      <button
                        key={tag}
                        type="button"
                        className="suggestion-tag"
                        onClick={() => handleAddTag(tag)}
                      >
                        #{tag}
                      </button>
                    ))}
                  </div>
                </div>
              </div>

              <div className="form-group">
                <textarea
                  name="content"
                  value={post.content}
                  onChange={handleInputChange}
                  className="post-content-input purple-input"
                  placeholder="开始你的写作之旅..."
                  rows="15"
                  required
                />
              </div>

              <div className="writing-tools">
                <div className="toolbar">
                  <button type="button" className="tool-btn" title="加粗">B</button>
                  <button type="button" className="tool-btn" title="斜体">I</button>
                  <button type="button" className="tool-btn" title="链接">🔗</button>
                  <button type="button" className="tool-btn" title="代码">{`</>`}</button>
                  <button type="button" className="tool-btn" title="引用">❝</button>
                </div>
                <div className="word-count">
                  字数：{post.content.length}
                </div>
              </div>
            </>
          ) : (
            <div className="preview-content">
              <h1 className="preview-title">{post.title || '无标题'}</h1>
              <div className="preview-meta">
                <span className="preview-category">{post.category || '未分类'}</span>
                <span className="preview-date">{new Date().toLocaleDateString()}</span>
              </div>
              <div className="preview-tags">
                {post.tags.split(',').filter(tag => tag.trim()).map((tag, index) => (
                  <span key={index} className="preview-tag">#{tag.trim()}</span>
                ))}
              </div>
              <div className="preview-body">
                {post.content.split('\n').map((paragraph, index) => (
                  paragraph.trim() ? <p key={index}>{paragraph}</p> : <br key={index} />
                ))}
              </div>
            </div>
          )}

          <div className="form-footer">
            <button 
              type="button" 
              className="draft-btn"
              onClick={handleSaveDraft}
            >
              保存草稿
            </button>
            <div className="publish-actions">
              <button type="button" className="preview-btn">
                预览
              </button>
              <button type="submit" className="publish-btn purple-btn">
                ✨ 发布文章
              </button>
            </div>
          </div>
        </form>

        <div className="writing-tips purple-card">
          <h3 className="tips-title">写作小贴士</h3>
          <ul className="tips-list">
            <li>💡 标题要吸引人但也要准确反映内容</li>
            <li>🌟 开头可以用一个有趣的故事或问题引入</li>
            <li>🔖 合理使用标签让更多人发现你的文章</li>
            <li>📝 段落不要太长，适当使用小标题</li>
            <li>✨ 结尾可以总结要点或提出思考</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default WritePost;